<template>
  <div class="statis-card" :style="[setColor, setSize]" :class="{ 'small': small, 'transparent': transparent }">
    <div class="arrow" :class="{ 'transparent': transparent }" :style="setArrowColor"></div>
    <i :class="[icon]" v-if="icon" />
    <fa :icon="icon" v-if="icon"/>
    <div class="info">
      <span>{{ title }}</span>
      {{ stat }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    transparent: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    stat: {
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    fa: {
      type: Boolean,
      required: false
    },
    color: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    small: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    setArrowColor () {
      if (this.color) {
        return {
          borderColor: this.color + ' transparent transparent transparent'
        }
      }

      return {}
    },
    setSize () {
      if (this.size) {
        return {
          fontSize: this.size + 'px'
        }
      }
    },
    setColor () {
      if (this.color) {
        return {
          borderColor: this.color,
          color: this.color
        }
      }

      return {}
    }
  }
}
</script>

<style lang="scss" scoped>

  .small {
    height: auto !important;
    margin-bottom: 0px !important;
    padding: 0px 20px;
  }

  .arrow {
    opacity: 0.5;
    position: absolute;
    right: 0px;
    top: 5px;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 12px 11.5px 0 11.5px;
    border-color: #008fcc transparent transparent transparent;
    -moz-transition: all 550ms ease-in-out;
    -webkit-transition: all 550ms ease-in-out;
    -o-transition: all 550ms ease-in-out;
    transition: all 550ms ease-in-out;
    transform: rotate(-135deg);

    &.transparent {
      display: none;
    }
  }

  .info {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;


    @include breakpoint (xs) {
      align-items: flex-start;
    }
  }

  .statis-card {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: white;
    color: $main;
    box-sizing: border-box;
    //border-bottom: 5px solid rgba(#008fcc, 0.5);
    -webkit-box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.01);
    -moz-box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.01);
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.01);
    font-size: 32px;
    margin-bottom: 20px;

    &.transparent {
      background-color: transparent;
      box-shadow: none;

      @include breakpoint (xs) {
        padding: 0px;
        border-radius: 5px;
        font-size: 22px;
        color: $text-light;
      }
    }

    @include breakpoint (xs) {
      margin-bottom: 0px;
    } 

    span {
      color: $text-light;
      font-size: 12px;

      @include breakpoint (xs) {
        color: $main;
        font-size: 10px;
        margin-bottom: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/StatCard.vue